import Lang from 'types/Lang';
import { TKioskPolicy } from 'types/kiosk/TKioskStartRegistrationData';

/** The kiosk's selectable languages, in selector order. Backend Languages enum: Dutch 1, French 2, English 3. */
export const KIOSK_LANGUAGES: Lang[] = [Lang.nl, Lang.fr, Lang.en];

const LANGUAGE_IDS: Record<Lang, number> = {
  [Lang.nl]: 1,
  [Lang.fr]: 2,
  [Lang.en]: 3,
};

export const toKioskLanguageId = (lang: Lang): number => LANGUAGE_IDS[lang];

/** Missing / unknown ids (e.g. a pre-upgrade response) map to null so callers keep the current language. */
export const fromKioskLanguageId = (languageId?: number | null): Lang | null =>
  KIOSK_LANGUAGES.find(lang => LANGUAGE_IDS[lang] === languageId) ?? null;

/** Tolerates a regional tag ('nl-BE') as well as the bare code the selector itself sets. */
export const toKioskLang = (language?: string | null): Lang | null => {
  const code = (language ?? '').slice(0, 2).toLowerCase();
  return KIOSK_LANGUAGES.find(lang => lang === code) ?? null;
};

/**
 * The policy text in the kiosk's current language. The server sends it in every kiosk language, so a
 * language switch picks it from what is already loaded, without a request. Falls back to the session-language
 * text when the server does not send the per-language set.
 */
export const pickKioskPolicies = (
  policiesByLanguage: Partial<Record<Lang, TKioskPolicy[]>>,
  fallback: TKioskPolicy[],
  language?: string | null,
): TKioskPolicy[] => {
  const lang = toKioskLang(language);
  return (lang && policiesByLanguage[lang]) || fallback;
};
